import styles from "./questionTitle.module.scss";

export const QuestionTitle = (props: Props) => {
  return (
    <div className={styles["wrapper"]}>
      <div className={styles["label"]}>{props.label}</div>
      <h1 className={styles["title"]}>{props.title}</h1>
    </div>
  );
};

interface Props {
  label: string;
  title: string;
}
